export default __webpack_public_path__ + "52c7b1a9e4ed4756559e6aeec469bed7.svg";